import { Box, Grid, Typography } from '@material-ui/core';
import { Add, Comment } from '@material-ui/icons';
import React, { useState } from 'react';
import { TabletButton } from '@campfire/tablet-button';
import { useVolunteerCommonProfileContext } from '../../VolunteerCommonProfileContext';
import { useCampfireQuery } from '../../../../../global/network/useCampfireQuery';
import { VolunteerCommonProfile } from '../../__generated__/VolunteerCommonProfile';
import { IV_COMBINED_COMMENT } from '../../../volunteers/incoming-volunteer/application--comment.gql';
import { ProfileCommentsList } from '../../../volunteers/common/ProfileCommentsList';
import {
  IVGetCombinedComments,
  IVGetCombinedCommentsVariables,
} from '../../../volunteers/incoming-volunteer/__generated__/IVGetCombinedComments';

interface Props {
  volunteer: VolunteerCommonProfile;
}

export const VolunteerCommentsSection = (props: Props) => {
  const {
    volunteerNameOptions: { preferredName },
  } = useVolunteerCommonProfileContext();
  const { volunteer } = props;

  const [dialogOpen, setDialogOpen] = useState<boolean>(false);
  const applicationId = volunteer.application?.applicationId ?? '';
  const profileId = volunteer.profile.profileId ?? '';

  const dialogClose = () => {
    setDialogOpen(false);
  };

  const { data: combinedComments, refetch } = useCampfireQuery<IVGetCombinedComments, IVGetCombinedCommentsVariables>(
    IV_COMBINED_COMMENT,
    { options: { variables: { applicationId: applicationId, profileId: profileId } } }
  );

  return (
    <Grid container spacing={2} direction='column' style={{ position: 'relative' }}>
      <Grid item xs={12} style={{ textAlign: 'left' }}>
        <Box display={'flex'} justifyContent={'space-between'} alignItems={'center'}>
          <Box>
            <Typography
              style={{ fontWeight: 600, fontSize: '18px', display: 'flex', alignItems: 'center', color: '#333' }}
            >
              <Comment style={{ fontSize: '14px', paddingRight: '5px' }} /> Comments
            </Typography>
            <Typography variant='body2' style={{ color: '#464646' }} align='left'>
              Comments on {preferredName}&apos;s profile
            </Typography>
          </Box>
          <TabletButton
            size='small'
            variant='contained'
            color='primary'
            aria-controls='options-menu'
            aria-haspopup='true'
            onClick={() => setDialogOpen(true)}
            startIcon={<Add />}
            style={{
              height: 36,
              border: '1px solid transparent',
              boxSizing: 'border-box',
              borderRadius: '4px',
              padding: '6px 12px',
              marginRight: '10px',
              color: '#fff',
            }}
          >
            Add
          </TabletButton>
        </Box>
        <hr style={{ borderTop: '.5px solid #e7e7e7', margin: '20px 0' }} />
      </Grid>
      <ProfileCommentsList
        applicationId={applicationId}
        profileId={volunteer.profile.profileId}
        applicationComments={combinedComments?.vm.application?.comments ?? []}
        profileComments={combinedComments?.vm.profile?.comments ?? []}
        refetch={refetch}
        dialogOpen={dialogOpen}
        dialogClose={dialogClose}
      />
    </Grid>
  );
};
